export const responsiveViewStyleHandleFn = (isFullscreen: boolean) => {
    if (isFullscreen) {
        document.body.classList.add('ele-full-screen-mode');
    } else {
        document.body.classList.remove('ele-full-screen-mode');
    }
};
